@if (data.isMobile) {
  <div class="max-w-[400px] w-full rounded-lg mx-auto bg-white">
    <div class="!text-subheadline-semibold mb-2 text-center px-4 !justify-center" matDialogTitle>
      {{ data.title }}
    </div>

    <mat-dialog-content
      [innerHTML]="data.message"
      class="text-footnote text-center !mb-5"></mat-dialog-content>

    <mat-dialog-actions class="flex gap-2 mt-8 !border-t !border-dividers">
      @if (data.secondaryAction) {
        <button
          class="secondary-action flex-1 cursor-pointer"
          [disabled]="isSecondaryProcessing"
          (click)="onSecondaryAction()">
          {{ data.secondaryAction.label }}
        </button>
      }
      <div class="h-[52px] w-px bg-dividers"></div>
      <button
        class="text-primary text-subheadline-medium flex-1 cursor-pointer"
        [disabled]="isPrimaryProcessing"
        (click)="onPrimaryAction()">
        {{ data.primaryAction.label }}
      </button>
    </mat-dialog-actions>
  </div>
} @else {
  <div mat-dialog-title>
    <h3 class="text-headline-3">{{ data.desktopTitle || data.title }}</h3>

    @if (!data.disableClose) {
      <button mat-dialog-close type="button" class="close-btn">
        <mtc-custom-icon svgName="x" size="lg" />
      </button>
    }
  </div>
  <mat-dialog-content>
    <p class="text-subheadline" [innerHTML]="data.desktopMessage || data.message"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (data.secondaryAction && !data.disableClose) {
      <mtc-button
        [variant]="data.secondaryAction.variant ?? 'error'"
        class="min-w-[114px]"
        [disabled]="isSecondaryProcessing"
        (click)="onSecondaryAction()">
        {{ data.secondaryAction.label }}
      </mtc-button>
    }
    <mtc-button
      [variant]="data.primaryAction.variant ?? 'primary'"
      class="min-w-[131px]"
      [disabled]="isPrimaryProcessing"
      (click)="onPrimaryAction()">
      {{ data.primaryAction.label }}
    </mtc-button>
  </mat-dialog-actions>
}
